module.exports = __webpack_public_path__ + "bf8457c0173a22e6834f3d47b590c5b8.svg";